import React from 'react'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'

export type Props = {
  name: string,
  label: string,
  value: string,
  rules?: any
} & React.InputHTMLAttributes<HTMLInputElement>

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: .875rem;
  font-weight: 400;
  text-align: left;
  line-height: 1.4875rem;
`

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  position: absolute;
  pointer-events: none;
`;

const StyledRadio = styled.span`
  display: inline-block;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: 2px solid #ccc;
  border-radius: 50%;
  margin-right: 8px;
  position: relative;

  ${HiddenRadio}:checked + & {
    border-color: ${props => props.theme.members.colors.appleGreen._60};
    background-color: ${props => props.theme.members.colors.appleGreen._60};
    border-width: 2px;

    &::after {
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  /* :disabled:checked は :checked より詳細度が高く、記述順に依存せず非活性が優先される */
  ${HiddenRadio}:disabled + &,
  ${HiddenRadio}:disabled:checked + & {
    border-color: ${props => props.theme.members.colors.silver._30};
    background-color: ${props => props.theme.members.colors.silver._30};
    cursor: not-allowed;
  }

  ${HiddenRadio}:disabled:checked + &::after {
    background: ${props => props.theme.members.colors.silver._70};
  }
`

export const StyledRadioInput: React.FC<Props> = (props: Props) => {
  const { register } = useFormContext()
  const { rules, ...inputProps } = props
  return (
    <StyledLabel
      className={props.disabled ? 'text-tech-silver-100 cursor-not-allowed' : 'text-member-gray-100'}
      data-cy={props.value}
    >
      <HiddenRadio
        type='radio'
        value={props.value}
        {...register(props.name, rules)}
        {...inputProps}
      />
      <StyledRadio data-cy="custom-radio" />
      {props.label}
    </StyledLabel>
  )
}
